(function ($, Cobalt, undefined) {
    Cobalt.Poll = {
        toggleButtonSelector: ".user-action-poll-view-results-link",
        labelSelector: ".user-action-poll-view-results-link > a > span",
        resultsSelector: ".poll-results",
        result: null,
        initialize: function (options) {

            Cobalt.Poll.initializeAjaxForms();

            if (options) {
                if (options.toggleButtonSelector != null) {
                    Cobalt.Poll.toggleButtonSelector = options.toggleButtonSelector;
                }

                if (options.labelSelector != null) {
                    Cobalt.Poll.labelSelector = options.labelSelector;
                }

                if (options.resultsSelector != null) {
                    Cobalt.Poll.resultsSelector = options.resultsSelector;
                }
            }

            Cobalt.Poll.results = $(Cobalt.Poll.resultsSelector);
            //before it checked if the results are hidden to change the label
            //the proper way should be set the label in the user actions, then check here for the label
            $.each(Cobalt.Poll.results, function (i, val) {
                var pollid = $(val).attr("results-poll-id");
                var label = $(Cobalt.Poll.labelSelector).filter(function (index) {
                    return $(this).parents("li:first").attr("data-poll-id") == pollid;
                });

                var text = $.trim($(label).text());
                if (text == L.Global.Polls.HideResults()) {
                    $(val).show();
                }
                else if ($(label).length > 0) {
                    $(val).hide();
                }
                else { //show if they dont have a show results button
                    $(val).show();
                }
            });

            $(Cobalt.Poll.toggleButtonSelector).click(function () {
                var pollid = $(this).attr("data-poll-id");
                var filteredResults = Cobalt.Poll.results.filter(function (index) {
                    return $(this).attr("results-poll-id") == pollid;
                });
                var resultsSelector = "li[data-poll-id='" + pollid + "']" + Cobalt.Poll.labelSelector;

                if (filteredResults.is(':hidden')) {
                    filteredResults.show();
                    $(resultsSelector).html(L.Global.Polls.HideResults());
                }
                else {
                    filteredResults.hide();
                    $(resultsSelector).html(L.Global.Polls.ViewResults());
                }
                return false;
            });

            $('#field-poll-add-poll-button').click(function () {
                var poll = $('#div-poll');
                if ($(this).val() == L.Global.Polls.RemovePoll()) {
                    $("#field-poll-form-create-poll").val("");
                }
                else {
                    $("#field-poll-form-create-poll").val("y");
                }
            });

            $(document).on("change", ".j-poll-type", function () {
                var options = $.map($(this).find("option"), function (option) { return $(option).val(); });
                var $example = $(this).closest(".j-poll-form").find(".j-poll-type-example");
                $.each(options, function (index, option) {
                    $example.removeClass("j-poll-type-example-" + option);
                });
                $example.addClass("j-poll-type-example-" + $(this).val());
            });

            $(".j-add-poll-button").click(function (e) {
                var $pollIndexesField = $(this).closest("form").find("input[name=hidden-poll-indexes]");
                var nextIndex = 0;
                if ($pollIndexesField.val()) {
                    nextIndex = parseInt($pollIndexesField.val().split(",").slice(-1)[0], 10) + 1;
                }
                $.get(Cobalt.Routes.Instance.PollGetPollForm($("#field-forum").val(), nextIndex), function (data) {
                    var $newPoll = $(data);
                    $(".j-poll").append($newPoll);
                    Cobalt.triggerHtmlInsert($newPoll);
                    if ($pollIndexesField.val()) {
                        $pollIndexesField.val($pollIndexesField.val() + "," + nextIndex);
                    } else {
                        $pollIndexesField.val(nextIndex);
                    }

                    Cobalt.Poll.updateChoiceOrder();
                });
            });

            $(document).on("click", ".j-delete-poll-button", function () {
                if (confirm("Delete?")) {
                    var $pollForm = $(this).closest(".j-poll-form");
                    var deletedIndex = $pollForm.find(".j-poll-index").val();
                    var $hiddenIndexField = $(this).parents("form").find(".j-poll-index");
                    var hiddenIndexes = $hiddenIndexField.val().split(",");
                    var newIndexes = $.grep(hiddenIndexes, function(value) {
                        return value != deletedIndex;
                    });
                    var newIndexString = "";
                    $.each(newIndexes, function(index, value) {
                        newIndexString += value + ",";
                    });
                    var pollID = $("#div-poll").attr("data-poll-id");
                    var parentID = $("#div-poll").attr("data-parent-id");
                    var parentTypeID = $("#div-poll").attr("data-parent-type-id");

                    newIndexString = newIndexString.substr(0, newIndexString.length - 1);
                    $hiddenIndexField.val(newIndexString);
                    
                    $pollForm.remove();
                    Cobalt.Poll.setOddEvenPolls();
                    Cobalt.Poll.updateTabIndexes();
                    Cobalt.Poll.updatePollIndexes();

                    var editPollModal = $(".edit-poll-modal");
                    if (editPollModal.length > 0) { //this means it already exists (not new)
                        $.post(Cobalt.Routes.Instance.PollDelete(parentTypeID, parentID, pollID), function(data) {
                            if (data.success) {
                                editPollModal.find(".ui-dialog-titlebar-close").click(); //close modal
                                location.reload();
                            }
                        });
                    }
                    
                    //if there are no more polls to choose from, Click the don't add a poll button
                    if ($('.j-poll-form').length === 0) {
                        $("#field-poll-add-poll-button").click();
                    }
                }
            });

            Cobalt.Poll.updateTabIndexesOnSort($(".j-poll"));

            Cobalt.runOnHtmlInsert(function ($content) {
                $content.find(".j-poll-type").trigger("change");
            });
            Cobalt.runOnHtmlInsert(Cobalt.Poll.setOddEvenPolls);
            Cobalt.runOnHtmlInsert(Cobalt.Poll.updateTabIndexes);
            Cobalt.runOnHtmlInsert(Cobalt.Poll.updateTabIndexesOnSort);

            var pollChoices = $('#field-poll-form-choices');
            var choiceCount = Cobalt.Poll.getChoiceCount();
        },
        setOddEvenPolls: function () {
            $.each($(".j-poll-form"), function (index, poll) {
                $(poll).removeClass("even odd");
                if ((index + 1) % 2 === 0) {
                    $(poll).addClass("even");
                } else {
                    $(poll).addClass("odd");
                }
                $(this).find('#field-poll-form-poll-index-' + index).attr('value', index);
            });
        },
        updatePollIndexes: function () {
            var index = 0;
            var newHiddenIndex = "";
            $('.j-poll-form').each(function () {
                $(this).find('#div-poll').attr('data-poll-id', index);
                newHiddenIndex += index + ",";
                index++;
            });
            $("#field-hidden-poll-indexes").val(newHiddenIndex);
        },
        updateTabIndexes: function () {
            $(".j-poll").find("input, select, textarea").each(function (index) {
                $(this).attr("tabindex", index + 1);
            });

            Cobalt.Poll.updateChoiceOrder();
        },
        updateTabIndexesOnSort: function (sortable) {
            $(sortable).find(".field-list").bind("sortstop", Cobalt.Poll.updateTabIndexes);
        },
        getChoiceCount: function () {
            return $('#field-poll-form-choices').find('input[type="text"]').length;
        },
        bindRemoveLink: function (link, parentElem) {
            var linkClicked = $(link);
            var inputRemoved = $(link).parent().find("input[type='text']");
            var hiddenField = $("input.hidden-poll-choice[data-choice-id='" + inputRemoved.attr("data-choice-id") + "']");
            parentElem.remove();
            hiddenField.remove();
        },
        initializeAjaxForms: function () {
            $("div.j-ajax-poll").each(function () {
                var pollID = $(this).find("#poll-vote").attr("data-poll-id");
                var $form = $(this).find("form");
                var $button = $form.find("button");
                var $buttonLabel = $button.find("span");
                var existingVotesCookie = $.cookie("PollVote-" + pollID);
                var existingVotes = "";
                if (existingVotesCookie != null) {
                    existingVotes = existingVotesCookie.split(',');
                }

                if (existingVotes.length > 0) {
                    var $choices = $form.find(".j-poll-choice > input");
                    $choices.each(function () {
                        var $choice = $(this);
                        var val = $choice.val();
                        if ($.inArray(val, existingVotes) >= 0) {
                            $choice.attr("checked", "checked");
                        }
                    });
                    $buttonLabel.text("Voted!")
                }

                $form.ajaxForm(
                {
                    type: "post",
                    cache: false,
                    success: function (data) {
                        $.cookie("PollVote-" + pollID, data.choices, { 'expires': 365 });
                        $buttonLabel.text("Voted!");
                    }
                }
            );
            });
        },
        updateChoiceOrder: function() {
            var positions = "";
            $(".p-poll-choice").each(function (i, element) {
                var id = $(element).attr("data-choice-id");

                positions += id + ":" + i + ";";
            });

            $("input[name=poll-form-choice-positions]").val(positions);
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Poll.js